import { Button } from "react-bootstrap";
import { Link } from "react-router-dom";
import { useUser } from "contexts/UserContext";
import { fetchOrchidAPI } from "utils/api";
import { usePhonePortraitContext } from "contexts/phone-portrait-context";

export const OrchidProGroupSessionJoinButton = ({
  groupSession,
  title,
  ...props
}) => {
  const { isPhonePortrait } = usePhonePortraitContext();
  const { user } = useUser();
  const zoom_meeting = groupSession.zoom_meeting || groupSession.zoomMeeting;
  const group_session_id =
    groupSession.group_session_id ||
    groupSession.group_timeslot_id ||
    groupSession.timeslotId;
  const twilio_url_code =
    groupSession.twilio_url_code || groupSession.twilioUrlCode;

  async function get_join_link(group_session_id, join_link) {
    const response = await fetchOrchidAPI(
      `/api/scheduler/v1/group_timeslot_orchid_pro/zoom_start_link/${group_session_id}`,
    );
    const url = response.ok
      ? (await response.json()).zoom_start_link
      : join_link;
    !isPhonePortrait
      ? window.open(url, "_blank")
      : window.location.replace(url);
  }

  return user && zoom_meeting?.join_link ? (
    <Button
      onClick={async (ev) => {
        ev.stopPropagation();
        await get_join_link(group_session_id, zoom_meeting.join_link);
      }}
      {...props}
    >
      {title || "Join Now"}
    </Button>
  ) : (
    <Button
      as={Link as any}
      to={`/group-video-chat?code=${twilio_url_code}`}
      onClick={(e) => e.stopPropagation()}
      {...props}
    >
      {title || "Join Now"}
    </Button>
  );
};

export const OrchidProAppointmentJoinButton = ({
  session,
  title,
  ...props
}) => {
  const twilio_url_code = session.twilio_url_code || session.twilioUrlCode;
  return (
    <Button
      as={Link as any}
      to={`/video-chat?code=${twilio_url_code}`}
      variant="primary"
      {...props}
    >
      {title || "Join Now"}
    </Button>
  );
};
